import React, { useMemo, useState } from "react";
import { FaTimes } from "react-icons/fa";

const EVENT_OPTIONS = [
  "Air Force Day",
  "Akshaya Tritiya",
  "Army Day",
  "Baisakhi",
  "Bhai Dooj",
  "Black Friday",
  "Boxing Day",
  "Buddha Purnima",
  "Carnival",
  "Chhath Puja",
  "Children's Day",
  "Chinese New Year",
  "Christmas",
  "Cyber Monday",
  "Day of the Dead",
  "Diwali",
  "Doctor's Day",
  "Durga Puja",
  "Earth Day",
  "Earth Hour",
  "Easter",
  "Eid al-Adha",
  "Eid al-Fitr",
  "Engineer's Day",
  "Farmer's Day",
  "Father's Day",
  "Friendship Day",
  "Gandhi Jayanti",
  "Ganesh Chaturthi",
  "Good Friday",
  "Gudi Padwa",
  "Guru Nanak Jayanti",
  "Halloween",
  "Hanukkah",
  "Hanuman Jayanti",
  "Holi",
  "Human Rights Day",
  "Independence Day",
  "International Asteroid Day",
  "International Biodiversity Day",
  "International Coffee Day",
  "International Dance Day",
  "International Day for Eradication of Poverty",
  "International Day for Tolerance",
  "International Day of Charity",
  "International Day of Cooperatives",
  "International Day of Democracy",
  "International Day of Education",
  "International Day of Families",
  "International Day of Forests",
  "International Day of Friendship",
  "International Day of Happiness",
  "International Day of Indigenous Peoples",
  "International Day of Non-Violence",
  "International Day of Older Persons",
  "International Day of Peace",
  "International Day of Persons with Disabilities",
  "International Day of Sport for Development and Peace",
  "International Day of Tolerance",
  "International Day of Women and Girls in Science",
  "International Day of Yoga",
  "International Friendship Day",
  "International Happiness Day",
  "International Jazz Day",
  "International Justice Day",
  "International Labour Day",
  "International Literacy Day",
  "International Men's Day",
  "International Migrants Day",
  "International Mother Language Day",
  "International Mountain Day",
  "International Museum Day",
  "International Nurses Day",
  "International Peace Day",
  "International Translation Day",
  "International Volunteer Day",
  "International Women in Engineering Day",
  "International Women in Science Day",
  "International Women's Day",
  "International Workers' Day",
  "International Youth Day",
  "Janmashtami",
  "Karva Chauth",
  "Kumbh Mela",
  "Kwanzaa",
  "Lohri",
  "Lunar New Year",
  "Mahashivratri",
  "Mahavir Jayanti",
  "Makar Sankranti",
  "Martyrs' Day",
  "Men's Day",
  "Mother's Day",
  "National Science Day",
  "National Sports Day",
  "National Unity Day",
  "National Voters Day",
  "National Youth Day",
  "Navratri",
  "Navy Day",
  "New Year's Day",
  "Oktoberfest",
  "Onam",
  "Parsi New Year",
  "Passover",
  "Pi Day",
  "Pongal",
  "Pride Day",
  "Raksha Bandhan",
  "Ram Navami",
  "Ramadan",
  "Republic Day",
  "Songkran",
  "St. Patrick's Day",
  "Teacher's Day",
  "Thanksgiving",
  "Ugadi",
  "UN Day",
  "United Nations Day",
  "Universal Children's Day",
  "Valentine's Day",
  "Vesak",
  "Vishu",
  "Women's Day",
  "World AIDS Day",
  "World AIDS Vaccine Day",
  "World Arabic Language Day",
  "World Asthma Day",
  "World Autism Awareness Day",
  "World Biodiversity Day",
  "World Blood Donor Day",
  "World Book Day",
  "World Braille Day",
  "World Brain Day",
  "World Cancer Day",
  "World Cities Day",
  "World Coconut Day",
  "World Consumer Rights Day",
  "World Creativity and Innovation Day",
  "World Diabetes Day",
  "World Elephant Day",
  "World Environment Day",
  "World Fair Trade Day",
  "World Food Day",
  "World Habitat Day",
  "World Health Day",
  "World Hearing Day",
  "World Heart Day",
  "World Hepatitis Day",
  "World Heritage Day",
  "World Human Rights Day",
  "World Humanitarian Day",
  "World Immunization Day",
  "World Intellectual Property Day",
  "World Kidney Day",
  "World Kindness Day",
  "World Malaria Day",
  "World Mental Health Day",
  "World Meteorological Day",
  "World Migratory Bird Day",
  "World Milk Day",
  "World Music Day",
  "World Music Therapy Day",
  "World NGO Day",
  "World No Tobacco Day",
  "World Oceans Day",
  "World Ozone Day",
  "World Philosophy Day",
  "World Photography Day",
  "World Poetry Day",
  "World Polio Day",
  "World Population Day",
  "World Post Day",
  "World Press Freedom Day",
  "World Pulses Day",
  "World Radio Day",
  "World Red Cross Day",
  "World Refugee Day",
  "World Savings Day",
  "World Science Day",
  "World Science Day for Peace and Development",
  "World Senior Citizens Day",
  "World Sight Day",
  "World Sleep Day",
  "World Soil Day",
  "World Sparrow Day",
  "World Statistics Day",
  "World Stroke Day",
  "World Students' Day",
  "World Teachers' Day",
  "World Telecommunication Day",
  "World Television Day",
  "World Theatre Day",
  "World Theatre for Children Day",
  "World Thinking Day",
  "World Toilet Day",
  "World Tourism Day",
  "World Tuberculosis Day",
  "World Vegan Day",
  "World Water Day",
  "World Wetlands Day",
  "World Wildlife Day",
  "Yoga Day"
];

const EventSelectorModal = ({
  isOpen,
  onClose,
  selectedEvent,
  setSelectedEvent,
  isPreview = false,
  className = ""
}) => {
  const [query, setQuery] = useState("");

  const filtered = useMemo(() => {
    const q = (query || "").toLowerCase();
    if (!q) return [];
    return EVENT_OPTIONS.filter(name => name.toLowerCase().includes(q)).slice(0, 20);
  }, [query]);

  if (!isOpen && !isPreview) return null;

  const selectOne = (name) => {
    setSelectedEvent(name);
    setQuery(name);
    if (!isPreview && typeof onClose === 'function') onClose();
  };

  const clearSelection = () => {
    setSelectedEvent(null);
    setQuery("");
    if (!isPreview && typeof onClose === 'function') onClose();
  };

  const Panel = (
    <div className={`glass-effect rounded-2xl border border-white/10 bg-[#111111]/95 backdrop-blur-2xl p-4 sm:p-5 w-[28rem] sm:w-[36rem] ${isPreview ? '' : 'shadow-2xl'}`}>
      <div className="flex items-center gap-2 mb-3">
        <h3 className="text-xs sm:text-sm font-medium text-white tracking-wide">Choose event</h3>
        {!isPreview && (
          <button type="button" className="ml-auto text-gray-300 hover:text-white" onClick={onClose} title="Close">
            <FaTimes className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      {/* Input field only */}
      <div className="relative">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Start typing an event..."
          className="w-full bg-[#0f0f0f] border border-white/10 rounded-lg px-3 py-2 text-[12px] text-gray-200 focus:outline-none focus:ring-0"
          disabled={isPreview}
        />

        {/* Suggestions dropdown */}
        {filtered.length > 0 && !isPreview && (
          <div className="absolute left-0 right-0 mt-1 max-h-72 overflow-y-auto rounded-lg border border-white/10 bg-[#0f0f0f] shadow-xl z-50">
            {filtered.map(name => (
              <button
                key={name}
                type="button"
                className="w-full text-left px-3 py-2 text-[12px] text-gray-200 hover:bg-white/5"
                onClick={() => selectOne(name)}
                title={name}
              >
                {name}
              </button>
            ))}
            {filtered.length === 0 && (
              <div className="px-3 py-2 text-[12px] text-gray-400">No results</div>
            )}
          </div>
        )}
      </div>

      {/* Selected event display */}
      {selectedEvent && (
        <div className="mt-3 p-2 bg-[#0f0f0f] border border-white/10 rounded-lg">
          <div className="flex items-center justify-between">
            <span className="text-[12px] text-white">{selectedEvent}</span>
            {!isPreview && (
              <button
                type="button"
                onClick={clearSelection}
                className="text-gray-400 hover:text-white text-[10px]"
                title="Clear selection"
              >
                Clear
              </button>
            )}
          </div>
        </div>
      )}

      {/* Helper note */}
      <div className="mt-2 text-[11px] text-gray-400">Select an event (optional). You can change it by typing again.</div>

      {!isPreview && (
        <div className="mt-4 flex justify-end">
          <button type="button" onClick={onClose} className="inline-flex items-center rounded-lg bg-white text-black px-3 py-1.5 text-[12px] hover:opacity-90">Done</button>
        </div>
      )}
    </div>
  );

  if (isPreview) {
    return (
      <div className={`absolute z-50 pointer-events-auto ${className}`}>
        {Panel}
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      {Panel}
    </div>
  );
};

export default EventSelectorModal;
